// extracted by mini-css-extract-plugin
export var closeButton = "_jm-1";
export var closeX = "_jm-3";
export var container = "_jm-0";
export var image = "_jm-2";